import {
  BudgetActions,
  BudgetPermissions,
  useBudgetContext,
  useBudgetProcessing,
  useErrorHandler,
} from 'hooks'
import { useState } from 'react'
import { Event } from 'typings'
import { trackBudgetChange } from 'ui'
import { FormAliasKeys, useFormAlias } from 'ui/providers/useFormAlias.constate'
import { useAnalytics } from 'use-analytics'
import { useDiscountType } from '../../../hooks/useDiscountType'
import { Promotion } from '../../typings'

export function useBudgetSave(props) {
  const { formState, budgetModalState } = props

  const { processBudget } = useBudgetProcessing()

  const budgetContext = useBudgetContext()
  const { originalValue, setPermission, setAction, action } = budgetContext

  const [budgetError, setBudgetError] = useState<{ status: number } | null>(
    null
  )

  const { track } = useAnalytics()

  const discountType = useDiscountType(formState)

  const { getAlias } = useFormAlias()

  const handleBudgetPermissionError = () => {
    setAction(BudgetActions.NONE)
    setPermission(BudgetPermissions.READ)

    trackBudgetChange({
      event: Event.BUDGET_PERMISSION_ERROR,
      injectedPayload: {
        permission: BudgetPermissions.READ,
      },
      formValues: formState.getValues(),
      budgetContext,
      discountType,
      track,
    })

    formState.setValue(
      getAlias(FormAliasKeys.budgetRestrictions),
      originalValue
    )
    budgetModalState.show()
  }

  useErrorHandler(budgetError, {
    onForbidden: handleBudgetPermissionError,
  })

  const save = async () => {
    const formValues: Promotion = formState.getValues()
    const result = await processBudget({
      budget: formValues.restrictions.budget,
      promotionId: formValues.id,
      promotionName: formValues.general.name,
    })
    if (result.success) {
      switch (action.current) {
        case BudgetActions.DELETE: {
          trackBudgetChange({
            event: Event.BUDGET_DELETE_SUCCESS,
            formValues: formState.getValues(),
            budgetContext,
            discountType,
            track,
          })
          break
        }
        case BudgetActions.CREATE:
        case BudgetActions.UPDATE: {
          trackBudgetChange({
            event: Event.BUDGET_SAVE_SUCCESS,
            formValues: formState.getValues(),
            budgetContext,
            discountType,
            track,
          })
          break
        }
        case BudgetActions.NONE:
          break
      }
    } else {
      setBudgetError({ status: result.errorCode || 500 })
    }
    return result
  }

  return { save, setBudgetError }
}
